import React, {Fragment} from 'react';
import Jobs from '../Jobs';

class Home extends React.Component{
    
    render(){
        return(
            <Fragment>
                <header className='hero'>
                    <h1>
                        We help you <br className="tablet-off" />
                        to Build Your Dream Career <br />
                        <span className="tablet-off">
                            Get amazing results trained with the best mentors who are professional Data Scientists.
                        </span>
                    </h1>
                    <a href="https://businesstoys.in/" target="_blank" rel="noreferrer" >
                        Visit Website
                    </a>
                </header>
                
                <Jobs updateModal={this.props.updateModal} login={this.props.login} updateLoading={this.props.updateLoading}   />
                
            </Fragment>

        )
    }
};

export default Home;